import { useCallback } from 'react';
import { useProcessMarkersForRouting } from '~/map/map/lassoTool/optimizeRouteBetweenPoints/useProcessMarkersForRouting';
import { useTranslation } from '../../../../../_shared/utils/hooks';
import { AppErrorType } from '../../../../../appError/appErrorType.enum';
import { useModal } from '../../../../../modal/useModal.hook';
import {
  type MarkersFetchDataResults, useMarkersInBoundary,
} from './useMarkersInBoundary';

export const useBoundaryDirections = () => {
  const [t] = useTranslation();
  const { getMarkersInBoundary, getMarkersInBoundaryTerritory } = useMarkersInBoundary();
  const { openModal: openAppErrorModal } = useModal('AppError');
  const { processSelectedData: sendMarkersToRouting } = useProcessMarkersForRouting();

  const onDataFetchSuccess = useCallback((response: MarkersFetchDataResults) => {
    sendMarkersToRouting(response.rowsData);
  }, [sendMarkersToRouting]);

  const onDataFetchError = useCallback(() => {
    openAppErrorModal({ appError: {
      type: AppErrorType.General,
      title: t('Failed to fetch data'),
      content: t('Something went wrong, please try again.'),
    } });
  }, [openAppErrorModal, t]);

  const addBoundaryDirections = useCallback((boundaryTerritoryGroupId: number, boundaryId: number) => {
    getMarkersInBoundary(boundaryTerritoryGroupId, boundaryId)
      .then(onDataFetchSuccess)
      .catch(onDataFetchError);
  }, [getMarkersInBoundary, onDataFetchSuccess, onDataFetchError]);

  const addBoundaryTerritoryDirections = useCallback((boundaryTerritoryGroupId: number, boundaryTerritoryId: string) => {
    getMarkersInBoundaryTerritory(boundaryTerritoryGroupId, boundaryTerritoryId)
      .then(onDataFetchSuccess)
      .catch(onDataFetchError);
  }, [getMarkersInBoundaryTerritory, onDataFetchSuccess, onDataFetchError]);

  return {
    addBoundaryDirections,
    addBoundaryTerritoryDirections,
  };
};
